import { ZoneHelpers } from '@diagram/helpers/ZoneHelpers';

import { ZoneValidationError, ZoneValidationErrorType, ZoneValidator } from 'models';

const checkFaultConnectionInductance: ZoneValidator['validator'] = ({ zones }) => {
    const errors: ZoneValidationError[] = [];

    zones.forEach((zone) => {
        const connectionsWithoutInductance = zone.connections.filter((connection) => !connection.inductance?.nom);

        if (connectionsWithoutInductance.length) {
            ZoneHelpers.warning(
                errors,
                ZoneValidationErrorType.FAULT_CONNECTION_INDUCTANCE_MISSING,
                zone,
                [],
                connectionsWithoutInductance,
            );
        }
    });

    return errors;
};

export { checkFaultConnectionInductance };
